<template>
  <div>
    <v-layout row wrap>
      <v-flex grow>
        <h2 class="headline pb-3">Bond Details</h2>
      </v-flex>
      <v-flex shrink>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn flat icon color="primary" @click.stop="saveBond()" v-on="on">
              <v-icon class="mr-1">save</v-icon>
            </v-btn>
          </template>
          <span>Save bond details</span>
        </v-tooltip>
      </v-flex>
    </v-layout>
    <v-form ref="leaseBond" v-model="valid" lazy-validation>
      <v-container grid-list-md>
        <v-layout row>
          <v-flex xs12>
            <v-radio-group
              v-model="bondStatus"
              :rules="[v => !!v || '']"
              label="Status"
              row
            >
              <v-radio label="Lodged" value="0"></v-radio>
              <v-radio label="Not lodged" value="1"></v-radio>
            </v-radio-group>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs6 ms4>
            <v-text-field
              v-model="lease.bond"
              label="Amount ($)"
              hint="Bond Amount"
              persistent-hint
              required
              :rules="[v => !!v || '']"
            ></v-text-field>
          </v-flex>
          <v-flex xs6 ms4>
            <v-text-field
              v-model="lease.bond_number"
              label="Number"
              hint="Bond number"
              persistent-hint
              required
              :rules="[v => !!v || '']"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs6 ms4>
            <v-text-field
              v-model="lease.bond_property_id"
              label="Property ID"
              required
              :rules="[v => !!v || '']"
            ></v-text-field>
          </v-flex>
          <v-flex xs6 ms4>
            <v-menu
              v-model="displayBondLodgeDate"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="formatDate(lease.bond_lodge_date)"
                  label="Lodge Date"
                  readonly
                  required
                  :rules="dateRules"
                  hint="Bond lodged date"
                  persistent-hint
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="lease.bond_lodge_date"
                no-title
                @input="displayBondLodgeDate = false"
              ></v-date-picker>
            </v-menu>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>
<script>
import moment from 'moment'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'LeaseBond',
  data() {
    return {
      valid: true,
      displayBondLodgeDate: false,
      dateRules: [
        (v) => !!v || '',
      ],
    }
  },
  computed: {
    ...mapGetters({
      lease: 'HouseList/Lease/getLease'
    }),
    bondStatus: {
      get() {
        return this.lease.bond_status.toString()
      },
      set(value) {
        this.lease.bond_status = parseInt(value)
      }
    }
  },
  methods: {
    ...mapActions({
      save: 'HouseList/Lease/updateLease'
    }),
    formatDate(date) {
      return date ? moment(date).format('DD MMMM YYYY') : null
    },
    saveBond() {
      if (this.$refs.leaseBond.validate()) {
        this.save(this.lease)
      }
    }
  },
}
</script>
